import { Divider, ScrollArea } from '@mantine/core';
import { LinksGroup } from '@/app/items/components/colapsed/LinksGroup';
import { menu } from '@/app/items/components/menu';

export function Collapsed() {
  const links = menu.map((item) => <LinksGroup {...item} key={item.label} />);

  return (
    <ScrollArea h='calc(100vh - 80px' mx='-md'>
      <Divider my='sm' />
      {links}
    </ScrollArea>
  );
}
